<template>
    <section
        class="section"
        :data-aside="$slots.aside ? sidebarPosition : null"
        :data-header="!!$slots.title || !!$slots.action"
    >
        <div class="section__wrapper">
            <header
                v-if="$slots.title || $slots.action"
                class="section__header"
            >
                <div
                    v-if="$slots.breadcrumbs"
                    class="section__breadcrumbs"
                >
                    <slot name="breadcrumbs" />
                </div>

                <span
                    v-if="$slots.lottie"
                    class="section__image--square"
                >
                    <slot name="lottie" />
                </span>
                <span
                    v-else-if="$slots.image"
                    class="section__image--square"
                >
                    <slot name="image" />
                </span>

                <span
                    v-if="$slots.title"
                    class="section__title"
                >
                    <slot name="title" />

                    <span
                        v-if="$slots.action"
                        class="section__action"
                    >
                        <slot name="action" />
                    </span>
                </span>

                <span
                    v-if="$slots.subtitle"
                    class="section__subtitle"
                >
                    <slot name="subtitle" />
                </span>

                <div
                    v-if="$slots.description"
                    class="section__intro"
                >
                    <slot name="description" />
                </div>
            </header>

            <div
                v-if="!!$slots.default || !!$slots.footer"
                class="section__content"
            >
                <slot />

                <div
                    v-if="$slots.footer"
                    class="section__footer"
                >
                    <slot name="footer" />
                </div>
            </div>

            <aside
                v-if="$slots.aside"
                class="section__aside"
            >
                <slot name="aside" />
            </aside>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        sidebarPosition: {
            type: String,
            default: 'right',
            required: false
        }
    }
};
</script>

<style lang="less" src="./BaseSection.less" />
